import {
  API_ERROR,
  TAX,
  TAX_LIST_SUCCESSFUL,
  TAX_ADD,
  TAX_ADD_SUCCESSFUL,
  TAX_EDIT,
  TAX_EDIT_SUCCESSFUL,
  TAX_DELETE,
  TAX_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  Taxlist: [],
  model: false,
  error_msg: null,
  rowdata: {},
};

const Tax = (state = initialState, action) => {
  switch (action.type) {
    case TAX:
      state = {
        ...state,
        loading: true,
      };
      break;
    case TAX_LIST_SUCCESSFUL:
      state = {
        ...state,
        Taxlist: action.payload.response.results,
        loading: false,
      };
      break;
    case TAX_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case TAX_ADD_SUCCESSFUL:
      state = {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: { id: 0 },
      };
      break;
    case TAX_EDIT:
      state = {
        ...state,
        model: true,
        rowdata: action.payload,
      };
      break;
    case TAX_EDIT_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        rowdata: { Id: 0 },
      };
      break;
    case TAX_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case TAX_SETROWDATA:
      state = {
        ...state,
        rowdata: action.payload,
        // model: true,
      };
      break;
    case MODEL_OPEN:
      state = {
        ...state,
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
        rowdata: { id: 0 },
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Tax;
